/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import * as React from 'react';
import { Col, Row, Alert } from 'reactstrap';

type Props = {|
  isUnderMaintenance: boolean,
|};

type GetComponent = (React.ComponentType<Props>) => React.ComponentType<Props>;

const getComponent: GetComponent = C => (props: Props) => {
  const { isUnderMaintenance } = props;
  return isUnderMaintenance ? (
    <Row style={{ height: '400px' }}>
      <Col className="my-auto text-center">
        <Alert color="warning" className="d-inline-block">
          <h4 id="model-under-maintenance" className="alert-heading">
            Model Under Maintenance
          </h4>
          <p className="mb-0">
            This model is currently undergoing maintenance or upgrades. Please check back later.
          </p>
        </Alert>
      </Col>
    </Row>
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <C {...props} />
  );
};

export default getComponent;
